<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户密码设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="账户密码" name="first">
        <el-form ref="ruleForm" :rules="rules" :model="form" style="margin-top: 10px">
          <el-row :gutter="20">
            <el-col :span="6"> </el-col>
            <el-col :span="10">
              <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="form.password"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即更新</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        password: "",
        user_id:"",
      },

      rules: {
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          { min: 6, max: 16, message: "长度在 6 到 16 个字符", trigger: "blur" },
        ],
      },
      activeName: "first",
    };
  },
  methods: {
    ...mapActions({
        setAgentUserPasswordAction: "setAgentUserPasswordAction",
    }),

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.setAgentUserPasswordAction({
            password: this.form.password,
            user_id:this.form.user_id

          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
 created() {
   this.form.user_id=this.$route.params.user_id

 },
    computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.agent_password.result,
    }),
  },
  watch: {
    result(val) {
      if (val.code == 302) {
        this.$message({
          message: "恭喜你，密码更新成功",
          type: "success",
        });
          this.$router.push({
              name: "agent_user_index",
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>
